import { AUFTRAG_API } from '@Constants/backendConstants';
import { useEntityAttachments } from '@Hooks/Attachments/useEntityAttachments';

/** Per-order attachments — thin wrapper over <c>useEntityAttachments</c> with the orders service URL baked in. */
export function useOrderAttachments(orderId: string | undefined) {
    return useEntityAttachments(AUFTRAG_API, 'orders', orderId);
}
